var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main workblank" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _vm.global.type == "manage"
                    ? _c(
                        "el-row",
                        { staticClass: "tool", attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("h4", [_vm._v("我的客户")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.customerChange },
                                  model: {
                                    value: _vm.customerValue,
                                    callback: function($$v) {
                                      _vm.customerValue = $$v
                                    },
                                    expression: "customerValue"
                                  }
                                },
                                _vm._l(_vm.customerData, function(item) {
                                  return _c("el-option", {
                                    key: item.number,
                                    attrs: {
                                      label: item.number + item.client_name,
                                      value: item.client_name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.global.type == "client"
                    ? _c("h4", [_vm._v("上传毛坯图/手绘图")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "prompt" }, [
                    _vm._v("可以前往AI改图消除底图中的障碍物！")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list" },
                    [
                      _vm._l(_vm.workblankData, function(item, index) {
                        return _c(
                          "li",
                          {
                            key: "workblank" + index,
                            ref: "workblankItem",
                            refInFor: true,
                            staticClass: "item"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "img_box",
                                attrs: {
                                  "data-count":
                                    item.workblank.length < 9
                                      ? item.workblank.length + 1
                                      : item.workblank.length
                                }
                              },
                              [
                                _vm._l(item.workblank, function(itemS, indexS) {
                                  return _c(
                                    "div",
                                    {
                                      key: "img" + itemS.workblank_id,
                                      staticClass: "img_item"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: itemS.photo_url,
                                          alt: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetail(index, indexS)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "el-icon-error",
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetaleW(index, indexS)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                item.workblank.length < 9
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "show-file-list": false,
                                          multiple: "",
                                          data: { space_cur: index },
                                          "http-request": _vm.handleDetail
                                        }
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: { icon: "el-icon-plus" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.space_type))
                            ]),
                            _vm._v(" "),
                            item.workblank_space_id != 0
                              ? _c("i", {
                                  staticClass: "el-icon-error",
                                  on: {
                                    click: function($event) {
                                      return _vm.toDetaleS(index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "add",
                              style: "height:" + _vm.workblankItemHeight + "px",
                              attrs: { icon: "el-icon-plus" },
                              on: {
                                click: function($event) {
                                  _vm.dialogFormVisible = true
                                }
                              }
                            },
                            [_vm._v("新建功能区")]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "btn_row", attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12, offset: 6 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.toPath }
                            },
                            [_vm._v("生成效果图")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "新增功能区",
                    visible: _vm.dialogFormVisible,
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogFormVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "请输入功能区名称"
                            },
                            model: {
                              value: _vm.workblankName,
                              callback: function($$v) {
                                _vm.workblankName = $$v
                              },
                              expression: "workblankName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.dialogFormVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.toAddS }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        "custom-class": "pop_img",
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true,
                        closeDetail: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogImg != ""
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: { src: _vm.dialogImg, alt: "" }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c0e2a99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0e2a99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Workblank.vue
// module id = null
// module chunks = 